import { useState } from "react";
import { useUser } from "@/context/UserContext";
import { useNavigate } from "react-router-dom";
import "@/styles/IslandList.css"; // Ensure correct path

interface IslandListPanelProps {
  onClose: () => void
}

export const IslandList = ({onClose}: IslandListPanelProps) => {

  const { islands } = useUser(); // Get islands from context
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true); // State to control visibility

  const handleEnterIslandWorld = (islandId: string) => {
    setIsOpen(false); // Close modal on navigation
    navigate(`/island/${islandId}`);
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose()
  }

  // Render null if not open
  if (!isOpen) return null;

  return (
    <div className="island-list-overlay"> {/* Use overlay for modal background */}
      <div className="flying-islands-panel">
        {/* Close button */}
        <button className="close-button" onClick={() => handleClose() }>✖</button>

        {/* Title */}
        <h3>🪐 Your Flying Islands</h3>

        {/* Conditional rendering based on islands count */}
        {islands && islands.length > 0 ? (
          <ul className="flying-islands-list">
            {islands.map(island => (
              // Use island.id as key for list items
              <li key={island.id}>
                {/* Display a truncated island ID or a more friendly name if available */}
                {/* Using a span allows specific styling for the ID */}
                <span>ID: {island.id ? `${island.id.substring(0, 6)}.` : 'N/A'}</span>
                {/* Button to enter the island world */}
                <button onClick={() => handleEnterIslandWorld(island.id)}>
                  Enter Island World
                </button>
              </li>
            ))}
          </ul>
        ) : (
          // Message when no islands are owned or while loading (if islands is initially null/undefined)
          <p>You don't own any islands yet.<br/>Visit the Market to purchase one!</p> // More helpful message
        )}
      </div>
    </div>
  );
};